// import './RegisterButton.css'


export default function RegisterButton (props){

    return(
    <button form='form1' id='registerButton' style={props.style} onClick={props.onClick}>
        {props.children||"REGISTRAR"}
    </button>)
}